import unfetch from 'unfetch';
import camelCase from './camel-case';

export function requestJson(url, options) {
  let response;

  return unfetch(typeof url === 'string' ? url : formatUrl(...url), options)
    .then(r => {
      response = r;
      return r.json();
    })
    .then(data => {
      if (!response.ok) {
        return Promise.reject(camelCase(data));
      }

      return { response, data: camelCase(data) };
    });
}

function formatUrl(base, params = {}) {
  const paramsArray = [];

  Object.keys(params).forEach(key => {
    const val = params[key];
    paramsArray.push(`${encodeURIComponent(key)}=${encodeURIComponent(val)}`);
  });

  if (!paramsArray.length) {
    return base;
  }

  return `${base}?${paramsArray.join('&')}`;
}
